exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sub-section-container{margin-bottom:38px}.sub-section{display:flex;margin:2.5px 0;padding:2.5px 0}.sub-section-left-content{flex:90%}.sub-section-right-content{flex:10%;margin-left:10px;text-align:right;align-self:center}.sub-section-title{margin:15px 0 2px;font-weight:500;letter-spacing:normal;color:#545454}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/SubSection/SubSection.scss
 ** module id = 1218
 ** module chunks = 0
 **/